const getAllowedFeatures = () => {
  const extendedDocument = document;
  try {
    return extendedDocument.featurePolicy?.allowedFeatures() || ['all'];
  } catch (error) {
    return ['all'];
  }
};
const canAutoplay = () => {
  const allowedFeatures = getAllowedFeatures();
  const canAutoplayFlag = allowedFeatures.find(feature => feature === 'all' || feature === 'autoplay');
  return !!canAutoplayFlag;
};

export { canAutoplay, getAllowedFeatures };
//# sourceMappingURL=browserFeatures.js.map
